const MESSAGES = {
  ERROR: {
    NO_DATA_FOUND: "No data found.",
    ADD_EMAIL: "Email is required",
    REMOVE_SPECIAL_CHARACTER: "No special characters allowed except comma.",
    VALID_EMAIL: "Add a valid email address",
    INVALID_ACTION_LINK:
      "This must be either a full URL or it should be the name of a view inside the Sola Pro app.",
    INVALID_BOOKING_LINK: "Please enter a valid Website URL (e.g. https://example.com).",
    INVALID_WEBSITE_LINK: "Please enter a valid Website URL (e.g. https://example.com).",
    ADD_PASSWORD: "Password is required",
    LOGIN: "Invalid email/password provided.",
    ADD_NAME: "Name is required",
    ADD_PHONE: "Phone number needs to be of 10 digit",
    ADD_VERIFICATION_CODE: "Verification code is required",
    VALID_VERIFICATION_CODE: "Add a valid verification code.",
    PASSWORD_LENGTH: "Password must be at least 8 characters",
    PASSWORD_UPPERCASE: "Password must contain at least one upper-case letter",
    PASSWORD_LOWERCASE: "Password must contain at least one lower-case letter",
    PASSWORD_NUMBER: "Password must contain at least one number",
    PASSWORD_SPECIAL: "Password must contain at least one special character",
    PASSWORD_CONFIRM: "Confirm password must match with password field",
    NO_LOGIN_USER_FOUND: "No login user found",
    ALIAS: "Alias is required",
    DISPLAY_NAME: "Display name is required",
    MENU_ORDER: "Menu order is required",
    MIN_MENU_ORDER: "Menu order is more than 0",
    ALREADY_MENU_ORDER: "Menu order already assigned",
    DESCRIPTION: "Description is required",
    REGISTER: "Problem while registration.",
    REGISTER_WITH_SSO:
      "You previously signed up with Google or Microsoft, Please go back and click continue with Google or continue with Microsoft to sign in.",
    VERIFY_USER: "Error while verifying user",
    SELECT_MENUS: "Select at least one menu",
    PROFILE_UPLOAD: "Error while upload profile picture",
    PREFERENCE_UPDATED: "Error while update preference",
    PROFILE_UPDATED: "Error while update profile",
    FIELD_REQUIRED: "This filed is required",
    FIELD_STRING_LENGTH_50_ERROR: "Maximum length should be upto 50 characters",
    FIELD_STRING_LENGTH_ERROR: "Maximum length should be upto 255 characters",
    FIELD_STRING_LENGTH_35_ERROR: "Maximum length should be upto 35 characters",
    FIELD_STRING_LENGTH_65_ERROR: "Maximum length should be upto 65 characters",
    FIELD_STRING_LENGTH_235_ERROR: "Maximum length should be upto 235 characters",
    FIELD_STRING_LENGTH_40_ERROR: "Maximum length should be upto 40 characters",
    PASSWORD_NOT_MATCH: "Password and confirm password is not match",
    TOO_LONG: "Please enter less than 400 words",
    USER_ACCESS: "Problem while saving user access.",
    SOMETHING_WENT_WRONG: "Something went wrong.",
    ACCOUNT_ALREADY_CONFIRMED: "Account is already confirmed",
    ACCOUNT_NOT_FOUND: "Account is not registered in system",
    BLOG_CREATE_ERROR: "Error while creating blog.",
    BLOG_UPDATE_ERROR: "Error while updating blog.",
    BLOG_DELETE_ERROR: "Error while deleting blog.",
    ARTICLE_CREATE_ERROR: "Error while creating Article.",
    ARTICLE_UPDATE_ERROR: "Error while updating Article.",
    ARTICLE_DELETE_ERROR: "Error while deleting Article.",
    ARTICLE_GET_ERROR: "Error while getting Article.",
    VALID_VALUE: "Error valid value.",
    GET_INQUIRIES_ERROR: "Error while getting all partner inquiries",
    INQUIRY_DELETE_ERROR: "Error while deleting Partner Inquiry.",
    INQUIRY_CREATE_ERROR: "Error while creating Partner Inquiry.",
    INQUIRY_UPDATE_ERROR: "Error while updating Partner Inquiry.",
    BRAND_CREATE_ERROR: "Error while creating Brand.",
    MSA_CREATE_ERROR: "Error while creating MSA.",
    MSA_UPDATE_ERROR: "Error while updating MSA.",
    MSA_DELETE_ERROR: "Error while deleting MSA.",
    GET_10KIMAGE_ERROR: "Error while getting all 10k images.",
    IMAGE_UPLOAD_ERROR: "Please upload a valid image.",
    SOLA_10K_SAVE_ERROR: "Error while Save Sola 10k Image.",
    SOLA_10K_DELETE_ERROR: "Error while deleting Sola 10k Image.",
    BOOKING_DELETE_ERROR: "Error while deleting Book Now Booking.",
    BOOKING_CREATE_ERROR: "Error while creating Book Now Booking.",
    BOOKING_UPDATE_ERROR: "Error while updating Book Now Booking.",
    BRAND_DETAILS_ERROR: "Error while getting brand's details.",
    BRAND_DELETE_ERROR: "Error while deleting Brand.",
    BRAND_UPDATE_ERROR: "Error while updating Brand.",
    GET_HOME_BUTTON_ERROR: "Error while getting all Home Button.",
    HOME_BUTTON_SAVE_ERROR: "Error while Save Home Button.",
    HOME_BUTTON_DELETE_ERROR: "Error while deleting Home Button.",
    GET_PRODUCT_INFORMATION_ERROR: "Error while getting all Product Information.",
    PRODUCT_INFORMATION_SAVE_ERROR: "Error while Save Product Information.",
    PRODUCT_INFORMATION_DELETE_ERROR: "Error while deleting Product Information.",
    SOLA_MY_IMAGE_SAVE_ERROR: "Error while Save Sola My Image.",
    SOLA_MY_IMAGE_DELETE_ERROR: "Error while deleting Sola My Image.",
    REPORT_SAVE_ERROR: "Error while Save Report.",
    REPORT_DELETE_ERROR: "Error while deleting Report.",
    CLASS_IMAGE_CREATE_ERROR: "Error while creating Class Images.",
    CLASS_IMAGE_DELETE_ERROR: "Error while deleting class Images.",
    GET_CONTACT_INQUIRIES_ERROR: "Error while getting all Contact Inquiries.",
    CONTACT_INQUIRIES_SAVE_ERROR: "Error while Save Contact Inquiries.",
    CONTACT_INQUIRIES_DELETE_ERROR: "Error while deleting Contact Inquiries.",
    LEAD_UPDATE_ERROR: "Error while update Leads.",
    MESSAGE_STATUS_UPDATE_ERROR: "Error while update Message status.",
    SEND_LEASE_ERROR: "Error while sending lease application.",
    STYLIST_MESSAGE_DELETE_ERROR: "Error while deleting Stylist Messages.",
    HOME_HERO_IMAGE_SAVE_ERROR: "Error while Save Report.",
    HOME_HERO_IMAGE_DELETE_ERROR: "Error while deleting Report.",
    MAINTENANCE_CONTACT_SAVE_ERROR: "Error while Save Maintenance Contacts.",
    MAINTENANCE_CONTACT_DELETE_ERROR: "Error while deleting Maintenance Contacts.",
    STATE_REGIONS_DELETE_ERROR: "Error while deleting State Region.",
    SIDE_MENU_DELETE_ERROR: "Error while deleting Side Menu.",
    SIDE_MENU_SAVE_ERROR: "Error while Save Side Menu.",
    DEAL_SAVE_ERROR: "Error while save Deals.",
    STYLIST_MESSAGE_SAVE_ERROR: "Error while Save Stylist Message.",
    STATE_REGION_SAVE_ERROR: "Error while Save State Regions.",
    WEBSITE_SAVE_ERROR: "Error while Save Update my Website.",
    WEBSITE_DELETE_ERROR: "Error while deleting Website.",
    GET_EDUCATION_HERO_IMAGES_ERROR: "Error while getting all Education Hero Images.",
    EDUCATION_HERO_IMAGES_DELETE_ERROR: "Error while deleting Education Hero Images.",
    EDUCATION_HERO_IMAGES_SAVE_ERROR: "Error while Save Education Hero Images.",
    STYLIST_UNIT_SAVE_ERROR: "Error while Save Stylist Unit.",
    STYLIST_UNIT_DELETE_ERROR: "Error while deleting Stylist Unit.",
    LEGACY_ADMIN_DELETE_ERROR: "Error while deleting Legacy Admin.",
    REGION_SAVE_ERROR: "Error while Save Region.",
    REGION_DELETE_ERROR: "Error while deleting Region.",
    TOOLS_DELETE_ERROR: "Error while deleting Tool and Resources.",
    TOOLS_CREATE_ERROR: "Error while creating Tool and Resources.",
    NOTIFICATION_SAVE_ERROR: "Error while Save Notification.",
    NOTIFICATION_DELETE_ERROR: "Error while deleting Notification.",
    EXTERNAL_CREATE_ERROR: "Error while creating External.",
    EXTERNAL_UPDATE_ERROR: "Error while updating External.",
    EXTERNAL_DELETE_ERROR: "Error while deleting External.",
    FRANCHISEE_INQUIRIES_SAVE_ERROR: "Error while Save Franchisee Inquiries.",
    FRANCHISEE_INQUIRIES_DELETE_ERROR: "Error while deleting Franchisee Inquiries.",
    FRANCHISE_BLOG_ERROR: "Error while updating Blog.",
    FRANCHISEE_BLOG_DELETE_ERROR: "Error while deleting Franchisee Blog.",
    SOLA_PROFESSIONAL_SAVE_ERROR: "Error while save salon professional.",
    ASSOCIATIONL_SAVE_ERROR: "Error while save salon professional.",
    SELECT_FOLLOWUP_IN_SEQUENCE: "Please select follow-up  in sequence",
    LEAD_DELETE_ERROR: "Error while Delete Leads.",
    SELECT_ATLEAST_ONE_SERVICE: "Please select atleast one service.",
    SELECT_ATLEAST_ONE_ACCESS: "Please select atleast one access.",
    LEAD_NOT_ABLE_TO_UPDATE_ERROR: "You are not able to edit this lead.",
    LEAD_NOT_ABLE_TO_VIEW_ERROR: "You are not able to view this lead.",
    USER_ALREADY_EXISTS_AS_OWNER: "Selected user is already registered as owner in this location.",
    OWNER_ALREADY_EXISTS_AS_USER: "Selected owner is already registered as user in this location.",
    MOVE_IN_SPECIAL: "Links not allowed",
    // Error for FAQS
    FAQ_DELETE_ERROR: "Error while Delete FAQ.",
    FAQ_ADD_ERROR: "Error while Adding FAQ.",
    FAQ_EDIT_ERROR: "Error while Editing FAQ.",
    AMENITIES_DELETE_ERROR: "Error while Delete AMENITIES.",
    AMENITIES_ADD_ERROR: "Error while Adding AMENITIES.",
    AMENITIES_EDIT_ERROR: "Error while Editing AMENITIES.",
    ASSIGN_CONTACT_ERROR: "Error while assigning contact.",
    REMOVE_CONTACT_ERROR: "Error while removing contact.",
    GET_SERVICE_ERROR: "Error while geting srvices.",
    CLOSES_AT_ERROR: "Closes at is required.",
    CLOSES_AT_BEFORE_OPENS_AT: "Closes at is before opens at.",
    SELECT_CORRECT_TIME_AFTER_CLOSES_AT:
      "Please select a time after closing for the first time slot.",
    // For Amount/Percent check
    AMOUNT_CHECK: "Amount is not grater or equal to the location Amount",
    PERCENT_CHECK: "Percentage is not grater the 100",
    // Studio is Occupied
    STUDIO_OCCUPIED: "Studio is already occupied",
    ONLY_10_DIGIT_PHONE: "Please enter only 10 digit mobile number.",
    // For not allowd duplicate name in studio
    NO_DUPLICATE_NAME: "Please enter unique name.",
    SELECT_8_AMENITIES: "Minimum 8 amenities should be selected.",
    SCORECARD_EXPORT_CSV_ERROR: "Failed to download scorecard",
    INVALID_STARTDATE: "Please select future start date.",
    INVALID_DATE: "Please select valid start date and end date.",
    // SD-3541
    TICKET_SUBJECT: "Subject must be less than 90 words.",
    TICKET_DESCRIPTION: "Description must be less than 1500 words.",
    SECONDARY_OWNER: "Please select Lead Owner.",
    SELECT_ONE: "Please select Atleast One.",
    FAIL_RESEND_MESSAGE: "Failed to resend message",
    // WORK_HOURS: "End time should be greater than Start time",
    // REQUIRED_WORK_HOURS: "Please select Start time and End time",
    // REQUIRED_TIMEZONE: "Please select Timezone from General Info",
  },
  SUCCESS: {
    LOGIN: "Logged in successfully.",
    REGISTER: "Registration successfully. Please check your email for verify account.",
    REGISTER_SSO: "Registration successfully.",
    OTP_SENT: "We have sent OTP to your email address, please check your email account.",
    ROLE_SAVE: "Role saved successfully.",
    ROLE_UPDATE: "Role updated successfully.",
    SUBMENU_ADD: "Submenu added successfully.",
    SUBMENU_UPDATE: "Submenu updated successfully.",
    MENU_ADD: "Menu added successfully.",
    MENU_UPDATE: "Menu updated successfully.",
    PASSWORD_UPDATE: "Password changed successfully.",
    USER_UPDATE: "User Updated Successfully.",
    USER_LOCK: "User locked successfully.",
    USER_UNLOCK: "User unlocked successfully.",
    USER_DELETE: "User deleted successfully.",
    USER_RESTORE: "User restored successfully.",
    PROFILE_UPLOAD: "Profile picture updated successfully",
    PREFERENCE_UPDATED: "Preference updated successfully",
    PROFILE_UPDATED: "Profile updated successfully",
    USER_ACCESS: "User access saved successfully.",
    BLOG_CREATE_SUCCESS: "Blog created successfully.",
    BLOG_UPDATE_SUCCESS: "Blog updated successfully.",
    BLOG_DELETE_SUCCESS: "Blog deleted successfully.",
    ARTICLE_CREATE_SUCCESS: "Article created successfully.",
    ARTICLE_UPDATE_SUCCESS: "Article updated successfully.",
    INQUIRY_CREATE_SUCCESS: "Partner Inquiry created successfully.",
    INQUIRY_UPDATE_SUCCESS: "Partner Inquiry updated successfully.",
    BRAND_CREATE_SUCCESS: "Brand created successfully.",
    BRAND_UPDATE_SUCCESS: "Brand updated successfully.",
    MSA_CREATE_SUCCESS: "MSA created successfully.",
    MSA_UPDATE_SUCCESS: "MSA updated successfully.",
    MSA_DELETE_SUCCESS: "MSA deleted successfully.",
    SOLA_10K_CREATE_SUCCESS: "Sola 10k Image created successfully.",
    SOLA_10K_UPDATE_SUCCESS: "Sola 10k Image updated successfully.",
    SOLA_10K_DELETE_SUCCESS: "Sola 10k Image deleted successfully.",
    BOOKING_CREATE_SUCCESS: "Book Now Booking created successfully.",
    BOOKING_UPDATE_SUCCESS: "Book Now Booking updated successfully.",
    BRAND_DELETE_SUCCESS: "BRAND deleted successfully.",
    HOME_BUTTON_CREATE_SUCCESS: "Home Button created successfully.",
    HOME_BUTTON_UPDATE_SUCCESS: "Home Button updated successfully.",
    HOME_BUTTON_DELETE_SUCCESS: "Home Button deleted successfully.",
    PRODUCT_INFORMATION_CREATE_SUCCESS: "Product Information created successfully.",
    PRODUCT_INFORMATION_UPDATE_SUCCESS: "Product Information updated successfully.",
    PRODUCT_INFORMATION_DELETE_SUCCESS: "Product Information deleted successfully.",
    SOLA_MY_IMAGE_CREATE_SUCCESS: "Sola My Image created successfully.",
    SOLA_MY_IMAGE_UPDATE_SUCCESS: "Sola My Image updated successfully.",
    SOLA_MY_IMAGE_DELETE_SUCCESS: "Sola My Image deleted successfully.",
    REPORT_CREATE_SUCCESS: "Report created successfully.",
    REPORT_UPDATE_SUCCESS: "Report updated successfully.",
    REPORT_DELETE_SUCCESS: "Report deleted successfully.",
    CLASS_IMAGE_CREATE_SUCCESS: "Class Images created successfully.",
    CLASS_IMAGE_DELETE_SUCCESS: "Class Images deleted successfully.",
    LOCATION_ADDED: "Location added successfully.",
    CONTACT_INQUIRIES_CREATE_SUCCESS: "Contact Inquiries created successfully.",
    CONTACT_INQUIRIES_UPDATE_SUCCESS: "Contact Inquiries updated successfully.",
    CONTACT_INQUIRIES_DELETE_SUCCESS: "Contact Inquiries deleted successfully.",
    CONTACT_INQUIRIES_UPDATE_INFO: "Existing deal updated with latest information.",
    LEAD_UPDATE_SUCCESS: "Lead updated successfully.",
    MESSAGE_STATUS_UPDATE_SUCCESS: "Message status updated successfully.",
    SEND_LEASE_SUCCESS: "Lease application sent successfully.",
    NOT_SENT_LEASE_SUCCESS: "Lease application added in not sent.",
    STYLIST_MESSAGE_DELETE_SUCCESS: "Stylist Message deleted successfully.",
    HOME_HERO_IMAGE_CREATE_SUCCESS: "Home Hero Image created successfully.",
    HOME_HERO_IMAGE_UPDATE_SUCCESS: "Home Hero Image updated successfully.",
    HOME_HERO_IMAGE_DELETE_SUCCESS: "Home Hero Image deleted successfully.",
    LEASE_SENT: "Lease has been sent successfully.",
    MAINTENANCE_CONTACT_UPDATE_SUCCESS: "Maintenance Contacts updated successfully.",
    MAINTENANCE_CONTACT_CREATE_SUCCESS: "Maintenance Contacts created successfully.",
    MAINTENANCE_CONTACT_DELETE_SUCCESS: "Maintenance Contacts deleted successfully.",
    STATE_REGIONS_DELETE_SUCCESS: "State Region deleted successfully.",
    SIDE_MENU_DELETE_SUCCESS: "Side Menu deleted successfully.",
    SIDE_MENU_UPDATE_SUCCESS: "Side Menu updated successfully.",
    SIDE_MENU_CREATE_SUCCESS: "Side Menu created successfully.",
    DEAL_CREATE_SUCCESS: "Deals created successfully.",
    DEAL_UPDATE_SUCCESS: "Deals updated successfully.",
    STYLIST_MESSAGE_CREATE_SUCCESS: "Stylist Message created successfully.",
    STYLIST_MESSAGE_UPDATE_SUCCESS: "Stylist Message updated successfully.",
    STATE_REGION_UPDATE_SUCCESS: "State Region updated successfully.",
    STATE_REGION_CREATE_SUCCESS: "State Region created successfully.",
    WEBSITE_UPDATE_SUCCESS: "Website updated successfully.",
    WEBSITE_DELETE_SUCCESS: "Website deleted successfully.",
    WEBSITE_REJECT_SUCCESS: "Sola Pro request rejected successfully.",
    EDUCATION_HERO_IMAGES_DELETE_SUCCESS: "Education Hero Images deleted successfully.",
    EDUCATION_HERO_IMAGES_UPDATE_SUCCESS: "Education Hero Images updated successfully.",
    EDUCATION_HERO_IMAGES_CREATE_SUCCESS: "Education Hero Images created successfully.",
    CATEGORY_UPDATE_SUCCESS: "Category updated successfully.",
    CATEGORY_CREATE_SUCCESS: "Category created successfully.",
    CATEGORY_DELETE_SUCCESS: "Category deleted successfully.",
    STYLIST_UNIT_UPDATE_SUCCESS: "Stylist Unit updated successfully.",
    STYLIST_UNIT_CREATE_SUCCESS: "Stylist Unit created successfully.",
    STYLIST_UNIT_DELETE_SUCCESS: "Stylist Unit deleted successfully.",
    RECORD_DELETE_SUCCESS: "Record deleted successfully.",
    RECORD_UPDATE_SUCCESS: "Record updated successfully.",
    RECORD_CREATE_SUCCESS: "Record inserted successfully.",
    LEGACY_ADMIN_CREATE_SUCCESS: "Legacy Account created successfully.",
    LEGACY_ADMIN_UPDATE_SUCCESS: "Legacy Account updated successfully.",
    LEGACY_ADMIN_DELETE_SUCCESS: "Legacy Account deleted successfully.",
    REGION_CREATE_SUCCESS: "Region created successfully.",
    REGION_UPDATE_SUCCESS: "Region updated successfully.",
    REGION_DELETE_SUCCESS: "Region deleted successfully.",
    TOOL_DELETE_SUCCESS: "Tool deleted successfully.",
    TOOL_CREATE_SUCCESS: "Tool created successfully.",
    TOOL_UPDATE_SUCCESS: "Tool updated successfully.",
    NOTIFICATION_CREATE_SUCCESS: "Notification created successfully.",
    NOTIFICATION_DELETE_SUCCESS: "Notification deleted successfully.",
    NOTIFICATION_UPDATE_SUCCESS: "Notification updated successfully.",
    EXTERNAL_UPDATE_SUCCESS: "External updated successfully.",
    EXTERNAL_DELETE_SUCCESS: "External deleted successfully.",
    EXTERNAL_CREATE_SUCCESS: "External created successfully.",
    FRANCHISEE_INQUIRIES_UPDATE_SUCCESS: "Franchisee Inquiries updated successfully.",
    FRANCHISEE_INQUIRIES_CREATE_SUCCESS: "Franchisee Inquiries created successfully.",
    FRANCHISEE_INQUIRIES_DELETE_SUCCESS: "Franchisee Inquiries deleted successfully.",
    LOCATION_CREATE_SUCCESS: "Location created successfully.",
    LOCATION_UPDATE_SUCCESS: "Location updated successfully.",
    LOCATION_DELETE_SUCCESS: "Location deleted successfully.",
    FRANCHISE_BLOG_UPDATE: "Blog updated successfully.",
    FRANCHISE_BLOG_CREATE: "Blog created successfully.",
    FRANCHISEE_BLOG_DELETE_SUCCESS: "Franchisee Blog deleted successfully.",
    SOLA_PROFESSIONAL_CREATE_SUCCESS: "Salon professional created successfully.",
    SOLA_PROFESSIONAL_UPDATE_SUCCESS: "Salon professional updated successfully.",
    SOLA_PROFESSIONAL_DELETE_SUCCESS: "Salon professional deleted successfully.",
    ASSOCIATION_CREATE_SUCCESS: "Association created successfully.",
    ASSOCIATION_UPDATE_SUCCESS: "Association updated successfully.",
    ASSOCIATION_DELETE_SUCCESS: "Association deleted successfully.",
    ASSOCIATION_LOCATION_ADD_SUCCESS: "Location added successfully.",
    ASSOCIATION_OWNER_ADD_SUCCESS: "Owner added successfully.",
    ASSOCIATION_USER_ADD_SUCCESS: "User added successfully.",
    ASSOCIATION_LOCATION_DELETE_SUCCESS: "Location deleted successfully.",
    ASSOCIATION_OWNER_DELETE_SUCCESS: "Owner deleted successfully.",
    ASSOCIATION_USER_DELETE_SUCCESS: "User deleted successfully.",
    DOWNLOAD_CENTER_DELETE_SUCCESS: "Download center deleted successfully.",
    NEW_LOCATION_REQUEST: "New location request accepted, you can access that after approved.",
    CHANGE_LOCATION_REQUEST:
      "Location details change request accepted, you can see that after approved.",
    LEAD_DELETE_SUCCESS: "Lead deleted successfully.",
    USER_UPDATE_SUCCESS: "User updated successfully",
    DATA_EXPORT_CREATED_SUCCESSFULLY:
      "Data Export Created Successfully. <br> <a href='/reports/download-center' style='color: #1A73E8; margin-top: 10px; display: inline-block'> View In Download Center</a>",
    SMS_REQUEST_SUCCESS: "New SMS request submited successfully",
    // Faq Messages
    FAQ_DELETE_SUCCESS: "Lead deleted successfully.",
    FAQ_DELETE_ERROR: "Error while Delete FAQ.",
    FAQ_ADD_SUCCESS: "FAQ added successfully.",
    FAQ_UPDATE_SUCCESS: "FAQ updated successfully",
    AMENITIES_DELETE_SUCCESS: "Amenities deleted successfully.",
    AMENITIES_DELETE_ERROR: "Error while Delete Amenities.",
    AMENITIES_ADD_SUCCESS: "Amenities added successfully.",
    AMENITIES_UPDATE_SUCCESS: "Amenities updated successfully",
    SCHEDULE_REPORT_SUCCESS: "Schedule Report successfully.",
    SCHEDULE_MEETING_SUCCESS: "Schedule meeting successfully.",
    UPDATE_SCHEDULE_MEETING_SUCCESS: "Schedule meeting update successfully.",
    CANCEL_SCHEDULE_MEETING_SUCCESS: "Cancel Schedule meeting.",
    SUCCESS_PHONE_NUMBER_ASSIGNED: "Phone Number assigned successfully to this location",
    SUCCESS_PHONE_NUMBER_BUY: "Phone Number purchased successfully.",
    SUCCESS_PHONE_DELETE: "Phone Number deleted successfully.",
    SUCCESS_PHONE_SETTING_UPDATE: "Phone Number settings updated successfully.",
    CONTACT_ASSIGN_SUCCESS: "Contact assign successfully.",
    CONTACT_REMOVE_SUCCESS: "Contact removed successfully.",
    SUCCESS_PHONE_TREE_SETTING_ADDED: "Phone Tree Settings Added successfully to this location",
    GET_ALL_SERVICES_SUCCESS: "Get Services successfully.",
    GET_ALL_SERVICES_FAIL: "Fail Services successfully.",
    DEAL_ENROLLED_SUCCESS: "Deal Enrolled successfully.",
    DEAL_UNENROLLED_SUCCESS: "Deal Unenrolled successfully.",
    WEBPAGE_CREATE_SUCCESS: "Webpage created successfully.",
    WEBPAGE_UPDATE_SUCCESS: "Webpage updated successfully.",
    WEBPAGE_DELETE_SUCCESS: "Webpage deleted successfully.",
    WEBPAGE_REQUEST_APPROVE_SUCCESS: "Webpage request approve successfully.",
    WEBPAGE_REQUEST_REJECT_SUCCESS: "Webpage request reject successfully.",
    WEBPAGE_REQUEST_DELETE_SUCCESS: "Webpage request deleted successfully.",
    ASSIGN_WEBPAGES_TO_USER: "Assign webpages to user.",
    // Sudio delete success
    DELETE_STUDIO_SUCCESS: "Studio deleted successfully",
    // Success and continue
    CONTACT_INQUIRIES_CREATE_SUCCESS_CONTINUE:
      "Contact Inquiries created successfully would you like to continue with this deal ?",
    MASTER_DATA_CREATED: "Data saved successfully",
    MASTER_DATA_DELETED: "Deleted data successfully",
    MASTER_DATA_UPDATED: "Data updated successfully",
    SCORECARD_EXPORT_CSV_SUCCESS: "Scorecard downloaded successfully",
    MESSAGE_RESEND:
      "Resend message request submitted successfully, it will show latest status within minute.",
  },
  GENERAL: {
    SURE_TO_DELETE: "Are you sure to delete this record?",
    SURE_TO_RESET: "Are you sure to reset values?",
    SURE_TO_REJECT: "Are you sure to reject this record?",
    CANCEL_REQUEST_TITLE: "Are you sure you want cancel facility request",
    COMMON_STRING_LENGTH_ERROR: "Character length should be min 3 and max 255.",
    COMMON_STRING_LENGTH_ERROR_LEADS: "Character length should be min 1 and max 255.",
    SURE_TO_REMOVE_CONTACT: "Are you sure to remove this contact?",
    SURE_TO_ASSIGN: "Are you sure you want assign this webpages to stylist ?",
    SURE_TO_DISCARD_LEASE: "Are you sure to discard your saved lease data ?",
    SURE_TO_UNGROUP_STUDIO: "Are you sure to ungroup studio ?",
  },
  INFO: {
    OPTIONAL: "Optional.",
    REQUIRED: "Required.",
    REQUIRED_LENGTH_255: "Required. Length up to 255.",
    OPTIONAL_LENGTH_255: "Optional. Length up to 255.",
    URL_NAME:
      "The URL name should contain only alphanumberic characters (A-Z and 0-9). No spaces or special characters are permitted. Dashes or underscores can be used to separate words (e.g. my-hair-is-awesome)",
    IMAGE_ALT_TEXT:
      "The alt text for an image describes what the image looks like (used by screen readers, the blind or visually impared and for search engine optimization)",
    HUBSPOT_EMAIL:
      "If provided Hubspot will use this email address - not the email address for inquries - to match contacts.",
    EMAIL_ADDRESS_FOR_STYLIST:
      "Comma separated emails. If blank - emails will be send to location's owner.",
    LATITUDE:
      "The latitude will be automatically set when a valid address is entered. You do not need to set the latitude manually (but you can if you really want to)",
    LONGITUDE:
      "The longitude will be automatically set when a valid address is entered. You do not need to set the longitude manually (but you can if you really want to)",
    CUSTOM_MAP_URL:
      "If you specify a custom maps URL, it will be used for your Map It link instead of using the link auto-generated from your address",
    WALK_IN_ENABLED:
      "If set to yes, there will be a toggle switch inside Sola Pro to turn on/off taking walk-ins for each salon professional at this location.",
    MAX_WALK_IN_TIME:
      "This field will set the maximum duration a salon professional at this location may set their taking walk-ins setting inside Sola Pro.",
    WALK_IN_END_OF_DAY:
      "If set, this is the time at the end of the day where all salon professionals talking walk-ins at this location should be automatically turned off.",
    WALK_IN_TIME_ZONE:
      "In order to turn off walk-ins automatically at the correct time, please select the time zone of this location",
    SERVICE_REQUEST_ENABLED:
      'If set to "Yes", there will be a Service Request button visible in Sola Pro connected to your Rent Manager account.',
    TOURS:
      "If you need help finding your tour iframe code, please <a href='https://www.ambientlight.co.uk/google-virtual-tours/how-to-add-your-google-virtual-tour-to-your-website/' target='_blank' style='color: #1A73E8; margin-top: 10px; display: inline-block'>click here</a>",
    MAIL_CHIP_IDS:
      "To sync to more than one Mailchimp list, please comma separate list IDs (e.g. 123abc, 456xyz, 789def)",
    CALL_FIRE_IDS:
      "To sync to more than one CallFire list, please comma separate list IDs (e.g. 123abc, 456xyz, 789def)",
    FIRSTNAME_OR_DISPLAYNAME:
      "If the Sola Pro wants to use their first name and last name then please use the separate fields, otherwise place the entire Display Name in this field.",
    RESERVED:
      "If set to yes, the stylist will not have a Sola webpage, appear in the directory or in searches.",
    PHONE_NUMBER_DISPLAY:
      "If set to hidden, the phone number will not be displayed anywhere on the Sola website",
    SEND_MESSAGE_BUTTON:
      "If set to hidden, the Send a Message button will not be displayed on your salon professional webpage",
    WEBSITE_BOOKING_URL:
      'It is critical that you include the "http://" portion of the URL. If you do not have online booking, leave this blank',
    SOCIAL_URL: 'Please use the full website address, including the "http://" portion of the URL',
    SURE_TO_ENROLLED_DEAL:
      "This deal is enrolled in automated communications. If you send a message manually, they will be unenrolled from the sequence. Are you sure you wish to proceed?",
  },
};

export default MESSAGES;
